import { MarkerCheckIcon } from './MarkerCheckIcon';

/**
 * author: Google
 * id 74C5E15E-D227-4272-94E6-EDFDD0F66C9A
 * name marker-check
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/marker-check.svg
 * tags
 */
export const MarkerTickIcon = MarkerCheckIcon;
export default MarkerTickIcon